import styled from 'styled-components';

export const ChatBadgesBlock = styled.div`
  height: 50px;
  border-radius: 10px;
  background: #f1f5f9cc;
  box-shadow: 0px 2px 4px 0px #0000000d inset;
  margin: 10px 1px;
  padding: 6px;
  display: flex;
  align-items: center;
  @media (max-width: 558px) {
    height: auto;
    display: flex;
  }
  @media (max-width: 396px) {
    display: flex;
  }
`;
export const ChatBadgesItemIconBlock = styled.div`
  position: relative;
  display: flex;
`;
export const ChatBadgesItem = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
  cursor: pointer;
  &:last-child {
    margin-right: 0;
  }
  &.active {
    background: #ffffff;
    box-shadow: 0px 1px 3px 0px #0000001a;
    border-radius: 8px;
    padding: 6px 5px;
  }
  @media (max-width: 558px) {
    margin-bottom: 16px;
    margin-top: 8px;
    /* &:first-child {
      margin-top: 16px;
    } */
  }
  @media (max-width: 396px) {
    margin-bottom: 0;
    margin-top: 0;
    /* &:first-child {
      margin-top: 16px;
    } */
  }
`;
export const ChatBadgesItemIcon = styled.img`
  width: 28px;
  height: 28px;
`;

export const ChatBadgesItemIconWrapper = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 40%;
  background: ${({ $bg }) => $bg};
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 16px;
    height: 16px;
  }
`;
export const ChatBadgesItemNotification = styled.div`
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 10px;
  background: #33ed58;
  box-shadow: 0px 3.43px 3.43px 0px #00000040;
  font-weight: 600;
  font-size: 9px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -6px;
  right: -5px;

  &.instaIcon {
    background: linear-gradient(90deg, #ad46ff 0%, #f6339a 50%, #ff6900 100%);
    top: -7px;
    right: -6px;
  }
  &.fbIcon {
    background: #2d6cdf;
  }
  &.TikTokIcon {
    background: linear-gradient(53.97deg, #501432 37.99%, #2d0f1e 94.39%);
  }
  &.ImapIcon {
    background: #0277ff;
  }
  &.ViberIcon {
    background: #6f3faa;
  }
  &.LinkedinIcon {
    background: #0077b5;
  }
`;
export const ChatBadgesItemTitle = styled.h5`
  font-weight: 500;
  font-size: 12px;
  color: #212529;
  margin-left: 6px;

  @media (max-width: 396px) {
    display: none;
  }
`;

export const NoAccessMessage = styled.div`
  padding: 24px;
  text-align: center;
  color: #62748e;
  font-size: 14px;
`;
